import { QboAppSettingKeys } from '@ztechapps/qbo.entity'
import { AppSettingKey as ProductAppSettingKey } from '@ztechapps/product.common'
import { AppSettingKey as TaskAppSettingKey } from '@ztechapps/task.common'
import { AppSettingKey as OrderAppSettingKey } from '@ztechapps/order.common'
import { AppSettingKey as ChatAppSettingKey } from '@ztechapps/chat.common'
export const AppSettingKey = {
  PRODUCTS_IN_ACTION: 'PRODUCTS_IN_ACTION',
  HEADER_CAROUSEL_IMAGE: 'HEADER_CAROUSEL_IMAGE',
  SHIP_FROM_ADDRESS: 'SHIP_FROM_ADDRESS',
  SHIP_PICKUP_START_TIME: 'SHIP_PICKUP_START_TIME',
  SHIP_PICKUP_END_TIME: 'SHIP_PICKUP_END_TIME',
  SHIP_PACKAGE_TYPES: 'SHIP_PACKAGE_TYPES',
  SHIP_ENABLE_PICKUP_SCHEDULE: 'SHIP_ENABLE_PICKUP_SCHEDULE',
  TAX_PRESETS: 'TAX_PRESETS',
  FILTER_CASCADE: 'FILTER_CASCADE',
  QZ_TRAY_CERTIFICATE: 'QZ_TRAY_CERTIFICATE',
  QZ_TRAY_SIGNATURE: 'QZ_TRAY_SIGNATURE',
  QZ_TRAY_OPTIONS: 'QZ_TRAY_OPTIONS',

  SHIP_CUSTOMS_CONTENTS: 'SHIP_CUSTOMS_CONTENTS',
  SHIP_CUSTOMS_NON_DELIVERY: 'SHIP_CUSTOMS_NON_DELIVERY',
  SHIP_CUSTOMS_ITEMS_TARIFF_CODE: 'SHIP_CUSTOMS_ITEMS_TARIFF_CODE',

  SHIP_TAX_TAXABLE_ENTITY_TYPE: 'SHIP_TAX_TAXABLE_ENTITY_TYPE',
  SHIP_TAX_IDENTIFIER_TYPE: 'SHIP_TAX_IDENTIFIER_TYPE',
  SHIP_TAX_VALUE: 'SHIP_TAX_VALUE',
  SHIP_TAX_ISSUING_AUTHORITY: 'SHIP_TAX_ISSUING_AUTHORITY',
  SHIP_RESTRICTED_ADDRESS: 'SHIP_RESTRICTED_ADDRESS',

  READY_FOR_PAYMENT_NOTIFICATION_TEMPLATE: 'READY_FOR_PAYMENT_NOTIFICATION_TEMPLATE',

  DEFAULT_SHIPTO: 'DEFAULT_SHIPTO',

  KEYBOARD_SHORTCUTS: 'KEYBOARD_SHORTCUTS',

  ...OrderAppSettingKey,
  ...ChatAppSettingKey,
  ...ProductAppSettingKey,
  ...QboAppSettingKeys,
  ...TaskAppSettingKey,
}
